// @ts-nocheck
import { getBackendUrl } from "../../utils";
import { useTranslation } from "react-i18next";
import { forwardRef, useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import { convertDate } from "../../services/luxonHelper";
import ToolTipComponent from "@CubeComponents/html/tooltip";
import css from "./Reviews.module.css";
import { reviewStageMapper } from "./ReviewsConstants";
import { updateReviewStatus, getReviewsGridColumns } from "./ReviewsHelper";
import CreateReviewModal from "./CreateReviewModal";
import ReviewProperties from "./ReviewProperties";
import { getReviewPageUrl, getReviewUrl } from "../../services/utils/helpers";
import UserNameTagComponent from "../../cubeComponent/html/UserNameTagComponent";
import SlickGrid from "@CubeComponents/html/SlickGrid";
import { createRoot } from "react-dom/client";
import { FaPlus } from "react-icons/fa";
import { RiFileInfoLine } from "react-icons/ri";
import IconComponent from "@CubeComponents/icons";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import { useDispatch } from "react-redux";
import { showToastNotification } from "@Actions/toast";
import { TOAST_TYPE_ERROR, TOAST_TYPE_SUCCESS } from "@Services/constants";
import DropdownButtonComponent from "@CubeComponents/form/DropdownButtonComponent";
import { IoChevronBack } from "react-icons/io5";
import ArchiveToggleIcon from "../../../../../assets/icons/svg/ArchiveToggleIcon.svg";
import ModalStateDialogComponent from "@CubeComponents/html/modal/ModalWithState";
import DeleteIcon from "@Components/StickySidebarViewer/assets/DeleteIcon";
import _ from "lodash";
import { recordStatus } from "helpers/constants";
import Text from "@CubeComponents/html/Text/Text";

interface ReviewsListProps {
  setIsRowSelected?: any;
  showOnlyGrid?: boolean;
  showNavigateColumn?: boolean;
  customQuery?: any;
  spaceId?: string;
  isActionable?: boolean;
  activeFilter?: any;
  selectedProjectIds?: any[];
  archiveToggle?: boolean;
}

const ReviewsList = forwardRef(
  (
    {
      setIsRowSelected,
      showOnlyGrid = false,
      showNavigateColumn = false,
      customQuery = null,
      spaceId,
      isActionable = false,
      activeFilter,
      selectedProjectIds,
      archiveToggle = false,
    }: ReviewsListProps,
    ref,
  ) => {
    const { t } = useTranslation();
    const [urlParams] = useSearchParams();
    const projectId: any = urlParams.get("projectId");
    const location: any = useLocation();

    const tempRef = useRef<any>(null);
    const dataGrid: any = ref || tempRef;
    const [createReviewModal, setCreateReviewModal] = useState<any>({ show: false });
    const [recordProperties, setRecordProperties] = useState<any>({
      show: false,
      details: {},
    });
    const [hasSelection, setHasSelection] = useState<any>(false);
    const [reviewsQuery, setReviewsQuery] = useState<any>(null);
    const [archiveModal, setArchiveModal] = useState<any>({
      show: false,
    });
    const [deleteModal, setDeleteModal] = useState<any>({
      show: false,
    });
    const [isLoadingReview, setIsLoadingReview] = useState<any>(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const reviewType: any = urlParams.get("type");

    useEffect(() => {
      const handleSelect = getReviewPageUrl(recordStatus.ACTIVE, urlParams.toString(), location.pathname);
      navigate(handleSelect);
    }, []);

    useEffect(() => {
      const initialQuery = buildBaseQuery(activeFilter);
      setReviewsQuery(initialQuery);
    }, [spaceId, projectId, isActionable, selectedProjectIds, activeFilter, customQuery, reviewType]);

    const buildBaseQuery = (filterType = null) => {
      const reviewTypeFlag = reviewType == recordStatus.ACTIVE ? recordStatus.ACTIVE : recordStatus.ARCHIVED;
      const params: any = {};

      if (spaceId) {
        params.spaceId = spaceId;
      } else if (projectId) {
        params.projectId = projectId;
      }

      if (isActionable) {
        params.isActionable = true;
      }

      if (filterType === "overdue") {
        params.overDue = true;
      } else if (filterType === "next7days") {
        params.next7days = true;
      } else if (filterType === "next30days") {
        params.next30days = true;
      }

      params.requiresCounts = true;
      params.selectedProjectIds = selectedProjectIds;
      params.recordStatusAction = reviewTypeFlag;

      if (customQuery) {
        return {
          ...customQuery,
          params: {
            ...(customQuery.params || {}),
            recordStatusAction: reviewTypeFlag,
          },
        };
      }

      return { params };
    };

    const closeModal = () => {
      setCreateReviewModal({ show: false });
    };

    const refreshGrid = () => {
      dataGrid?.current?.refresh();
    };

    const closeProperties = () => {
      setRecordProperties({ show: false, details: {} });
    };

    const handlePropertiesOpen = () => {
      dataGrid.current.dataView.getAllSelectedItems().length === 1 && propertiesToolClicked();
    };

    const propertiesBtnTemplate = () => {
      return <RiFileInfoLine size={18} onClick={handlePropertiesOpen} className="cursor-pointer" />;
    };

    const handleSelectedOption = async (args: any) => {
      const reviewType = args.item.properties.id == recordStatus.ARCHIVED ? recordStatus.ARCHIVED : recordStatus.ACTIVE;
      let handleSelect = getReviewPageUrl(reviewType, urlParams.toString(), location.pathname);
      navigate(handleSelect);
    };

    const toolbarClickHandler = (toolId: any, args: any) => {
      if (toolId === "create_review") {
        createReviewToolClicked();
      }
      if (toolId === "view_Archive_And_Unarchive_Review") {
        handleSelectedOption(args);
      }
    };

    const handleArchiveClick = async () => {
      setArchiveModal({
        show: true,
      });
    };

    const archiveBtnTemplate = () => (
      <ButtonComponent buttonType={BUTTON_TYPES.TEXT_BUTTON} onClick={() => handleArchiveClick()}>
        <div className="flex items-center gap-[var(--size-5)]">
          <img src={ArchiveToggleIcon} alt="" />
          <span>{reviewType == recordStatus.ACTIVE ? t("Archive") : t("Unarchive")}</span>
        </div>
      </ButtonComponent>
    );

    const deleteBtnTemplate = () => (
      <ButtonComponent buttonType={BUTTON_TYPES.TEXT_BUTTON} onClick={() => handleDeleteClick()}>
        <div className="flex items-center gap-[var(--size-5)]">
          <DeleteIcon size={16} className={undefined} />
          <span>
            <Text>{t("Delete")}</Text>
          </span>
        </div>
      </ButtonComponent>
    );

    const viewArchiveAndUnarchiveReviewTemplate = () => (
      <DropdownButtonComponent
        select={(args) => toolbarClickHandler("view_Archive_And_Unarchive_Review", args)}
        items={
          reviewType == recordStatus.ACTIVE
            ? [
                {
                  text: t("View Archived Reviews"),
                  id: recordStatus.ARCHIVED.toString(),
                },
              ]
            : [
                {
                  text: t("View Active Reviews"),
                  id: recordStatus.ACTIVE.toString(),
                },
              ]
        }
        cssClass="e-caret-hide"
        id="view_Archive_And_Unarchive_Review"
      >
        <IconComponent name="threedots" />
      </DropdownButtonComponent>
    );

    const handleBackToActive = () => {
      const handleSelect = getReviewPageUrl(recordStatus.ACTIVE, urlParams.toString(), location.pathname);
      navigate(handleSelect);
    };

    const performReviewOperation = async (reviewType: any) => {
      setIsLoadingReview(true);
      const selectedRecords = dataGrid.current.dataView.getAllSelectedItems();
      const reviewIds = selectedRecords.map((r: any) => r._id);

      let recordStatusAction;
      let successMessage;
      let errorMsg;
      let modalSetter;
      const reviewTypeNumber = Number(reviewType);
      switch (reviewTypeNumber) {
        case recordStatus.ACTIVE:
          recordStatusAction = recordStatus.ARCHIVED;
          successMessage = t("The review(s) has been archived successfully!");
          errorMsg = t("The review(s) could not be archived.");
          modalSetter = () => setArchiveModal({ show: false });
          break;
        case recordStatus.ARCHIVED:
          recordStatusAction = recordStatus.ACTIVE;
          successMessage = t("The review(s) has been unarchived successfully!");
          errorMsg = t("The review(s) could not be unarchived.");
          modalSetter = () => setArchiveModal({ show: false });
          break;
        case recordStatus.DELETED:
          recordStatusAction = recordStatus.DELETED;
          successMessage = t("The review(s) has been deleted successfully!");
          errorMsg = t("The review(s) could not be deleted.");
          modalSetter = () => setDeleteModal({ show: false });
          break;
        default:
          throw new Error("Invalid operation type");
      }

      const operation = {
        reviewIds,
        recordStatusAction,
        projectId,
      };

      try {
        const response = await updateReviewStatus(operation);
        setIsLoadingReview(false);
        if (response.data?.status) {
          dataGrid.current.refresh();
          dispatch(
            showToastNotification({
              content: successMessage,
              type: TOAST_TYPE_SUCCESS,
            }),
          );
        } else {
          throw new Error(response.data.errorMessage);
        }
      } catch (err: any) {
        dispatch(
          showToastNotification({
            content: err.errorMessage || errorMsg,
            type: TOAST_TYPE_ERROR,
          }),
        );
      } finally {
        modalSetter();
      }
    };

    const toolbarForReviews = [
      ...(!isActionable && reviewType == recordStatus.ACTIVE
        ? [
            {
              name: t("Create Review"),
              id: "create_review",
              prefixIconTemplate: <FaPlus size={12} color="black" />,
            },
          ]
        : []),
      {
        id: "archive_review",
        template: archiveBtnTemplate,
        hidden: !archiveToggle,
        disabled: !hasSelection,
      },
      {
        id: "delete_Review",
        hidden: !archiveToggle,
        template: deleteBtnTemplate,
        disabled: !hasSelection,
      },
      {
        id: "review_properties",
        template: propertiesBtnTemplate,
        disabled: !hasSelection,
        rightAllign: true,
      },
      {
        id: "view_Archive_And_Unarchive_Review",
        template: viewArchiveAndUnarchiveReviewTemplate,
        hidden: !archiveToggle,
        rightAllign: true,
      },
    ];

    const createReviewToolClicked = () => {
      setCreateReviewModal({ show: true });
    };

    const propertiesToolClicked = () => {
      const selectedRecords = dataGrid.current.dataView.getAllSelectedItems();
      setRecordProperties((prev: any) =>
        prev.show ? { show: false, details: {} } : { show: true, details: selectedRecords[0] },
      );
    };

    const selectionEvents = () => {
      if (!dataGrid.current) return;

      const selectedRecords = dataGrid.current.dataView.getAllSelectedItems();

      if (setIsRowSelected) setIsRowSelected(selectedRecords.length > 0);
      if (selectedRecords.length !== 1) closeProperties();
      if (showOnlyGrid) return;
    };

    const handleDeleteClick = async () => {
      setDeleteModal({
        show: true,
      });
    };

    const handleOpenReviewClick = ({
      projectId,
      spaceId,
      reviewId,
      newTab,
    }: {
      projectId: string;
      spaceId: string;
      reviewId: string;
      newTab: any;
    }) => {
      const url = getReviewUrl(projectId, spaceId, reviewId);
      if (newTab) {
        window.open(url);
      } else {
        navigate(url);
      }
    };
    const recordClick = (args: any) => {
      if (args.detail.args.cell === 0) {
        return;
      }
      const rowData = dataGrid.current.slickGrid.getDataItem(args.detail.args.row);
      const reviewId = rowData._id;
      const spaceId = rowData.spaceId;
      const projectId = rowData.projectData._id;
      handleOpenReviewClick({ projectId, spaceId, reviewId, newTab: false });
    };

    const createdDateTemplate = (args: any) => {
      if (!args.createdDate) return "-";

      const dateFormat = convertDate(Number(args.createdDate), "dateForTooltip");
      const container = document.createElement("div");
      const root = createRoot(container);

      root.render(
        <ToolTipComponent position="bottom" content={dateFormat}>
          <span>{convertDate(Number(args.createdDate), "dateForText")}</span>
        </ToolTipComponent>,
      );

      return container;
    };

    const finishedDateTemplate = (args: any) => {
      if (!args.finishedDate) return "-";

      const dateFormat = convertDate(Number(args.finishedDate), "dateForTooltip");
      const container = document.createElement("div");
      const root = createRoot(container);

      root.render(
        <div className={css.createdDateTooltip}>
          <ToolTipComponent showTipPointer position="bottom" content={dateFormat}>
            <span>{convertDate(Number(args.finishedDate), "dateForText")}</span>
          </ToolTipComponent>
        </div>,
      );

      return container;
    };

    const nextActionDueDateTemplate = (args: any) => {
      if (!args.nextActionDueDate) return "-";

      const dueDateTimestamp = args.nextActionDueDate;
      const currentTimestamp = Date.now();
      const msInOneDay = 1000 * 60 * 60 * 24;

      const daysDifference = Math.ceil((dueDateTimestamp - currentTimestamp) / msInOneDay);

      const isOverdue = daysDifference < 0 || Object.is(daysDifference, -0);
      const isDueSoon = daysDifference >= 0 && daysDifference <= 3;

      const formattedDate = convertDate(dueDateTimestamp, "dateForText");

      let badgeColor = "";
      let tooltipMessage = "";

      if (isOverdue) {
        badgeColor = "bg-red-500";
        tooltipMessage = `Due date exceeded by ${Math.abs(daysDifference)} day(s)`;
      } else if (isDueSoon) {
        badgeColor = "bg-yellow-400";
        tooltipMessage = `Due date approaching in ${daysDifference} day(s)`;
      }

      const container = document.createElement("div");
      const root = createRoot(container);

      root.render(
        <div className={css.createdDateTooltip}>
          <div className="flex items-center gap-2">
            <span>{formattedDate}</span>

            {tooltipMessage && (
              <ToolTipComponent showTipPointer position="bottom" content={tooltipMessage}>
                <span
                  className={`w-5 h-5 flex items-center justify-center rounded-full text-white text-xs ${badgeColor}`}
                >
                  !
                </span>
              </ToolTipComponent>
            )}
          </div>
        </div>,
      );

      return container;
    };

    const waitingForTemplate = (args: any) => {
      const { currentReviewLevel, reviewStatus } = args;

      if (["Closed", "Revoked"].includes(reviewStatus) || !currentReviewLevel) {
        return "-";
      }

      return `${currentReviewLevel.serial} - ${currentReviewLevel.title}`;
    };

    const reviewSerialIdTemplate = (args: any) => {
      return `RE - ${args.serialId}`;
    };

    const creatorTemplate = (args: any) => {
      const container = document.createElement("div");
      const root = createRoot(container);

      root.render(
        <div>
          <UserNameTagComponent id={args.createdBy?.userId} />
        </div>,
      );

      return container;
    };

    const workFlowTemplate = (args: any) => {
      const container = document.createElement("div");
      const root = createRoot(container);

      root.render(<div>{args.workflow.name}</div>);

      return container;
    };

    const projectNameTemplate = (args: any) => {
      const container = document.createElement("div");
      const root = createRoot(container);

      root.render(<div>{args.projectData.description}</div>);

      return container;
    };

    const stagetemplate = (stage: any, wrapperClass: any) => {
      const container = document.createElement("div");
      const root = createRoot(container);

      root.render(
        <div className={`${css[wrapperClass]} ${css[reviewStageMapper[stage]?.containerClass]}`}>
          <div className={`${css.reviewStageIndicator} ${css[reviewStageMapper[stage]?.indicatorClass]}`} />
          <p className={css.reviewStatus}>{reviewStageMapper[stage]?.name}</p>
        </div>,
      );

      return container;
    };

    const reviewStageTemplate = (args: any) => {
      return stagetemplate(args.reviewStatus, "reviewStageInGrid");
    };

    const navigateTemplate = (args: any) => {
      const reviewId = args._id;
      const spaceId = args.spaceId;
      const projectId = args.projectData._id;
      const container = document.createElement("div");
      const root = createRoot(container);

      root.render(
        <IconComponent
          onClick={(e) => {
            e.stopPropagation();
            handleOpenReviewClick({ projectId, spaceId, reviewId, newTab: true });
          }}
          className="cursor-pointer"
          name="openInViewer"
        />,
      );

      return container;
    };

    const callbackForVisibleColumnsUpdate = (updatedColumns: any) => {
      const findEle = (col: any) => {
        return updatedColumns.find((c: any) => c.id === col.id);
      };
      setReviewsGridColumns((prevColumns: any) =>
        prevColumns.map((col: any) => {
          const updated = findEle(col);
          if (updated) {
            return {
              ...col,
              hidden: !updated.hidden,
            };
          }
          return col;
        }),
      );
    };

    const [reviewsGridColumns, setReviewsGridColumns] = useState<any>(() =>
      getReviewsGridColumns({
        creatorTemplate,
        createdDateTemplate,
        finishedDateTemplate,
        nextActionDueDateTemplate,
        waitingForTemplate,
        reviewSerialIdTemplate,
        reviewStageTemplate,
        workFlowTemplate,
        projectNameTemplate,
        navigateTemplate,
        showNavigateColumn,
      }).map((column: any) => {
        if (
          [
            "description",
            "finishedDate",
            "numberOfEntitiesAttached",
            "reviewStatus",
            "createdBy",
            "createdDate",
            "",
          ].includes(column.id)
        ) {
          return { ...column, hidden: true };
        }
        return column;
      }),
    );

    const getHeader = () => (
      <div className="flex flex-col py-2">
        <div className="text-2xl font-semibold ms-3">
          <Text>{t("Reviews")}</Text>
        </div>
        <div className="text-sm mt-2 ms-3">
          <Text>{t("All the reviews in this project")}</Text>
        </div>
      </div>
    );

    const closeArchiveModal = () => {
      setArchiveModal({ show: false });
    };

    const archiveModalContent = () => {
      const isArchiving = reviewType == recordStatus.ACTIVE;
      const confirmationText = isArchiving
        ? t("Are you sure you want to archive the selected review(s)?")
        : t("Are you sure you want to unarchive the selected review(s)?");
      return <div>{confirmationText}</div>;
    };

    const archiveModalFooter = () => {
      const isArchiving = reviewType == recordStatus.ACTIVE;
      const actionButton = isArchiving ? t("Archive") : t("Unarchive");

      return (
        <div className="flex gap-4">
          <ButtonComponent
            buttonType={BUTTON_TYPES.GRADIENT_BUTTON}
            onClick={() => performReviewOperation(reviewType)}
            loading={isLoadingReview}
          >
            {actionButton}
          </ButtonComponent>
          <ButtonComponent buttonType={BUTTON_TYPES.BORDER_BUTTON} onClick={closeArchiveModal}>
            <Text>{t("Cancel")}</Text>
          </ButtonComponent>
        </div>
      );
    };

    const deleteModalHeader = () => {
      return (
        <div className="px-6 py-4">
          <span className="text-xl font-semibold">
            <Text>{t("Delete Review(s)")}</Text>
          </span>
        </div>
      );
    };

    const deleteModalContent = () => {
      return (
        <div className="px-6">
          <Text>{t("Are you sure you want to delete the selected review(s)?")}</Text>
        </div>
      );
    };

    const deleteModalFooter = () => {
      return (
        <div className="flex justify-start px-6 py-4 gap-4">
          <ButtonComponent
            buttonType={BUTTON_TYPES.GRADIENT_BUTTON}
            onClick={() => performReviewOperation(recordStatus.DELETED)}
            loading={isLoadingReview}
          >
            <Text>{t("Delete")}</Text>
          </ButtonComponent>
          <ButtonComponent buttonType={BUTTON_TYPES.BORDER_BUTTON} onClick={handleDeleteModalCancel}>
            <Text>{t("Cancel")}</Text>
          </ButtonComponent>
        </div>
      );
    };

    const handleDeleteModalCancel = () => {
      setDeleteModal({ show: false });
    };

    const handleSelectedRowIdsChanged = () => {
      if (_.get(dataGrid, "current.dataView")) {
        const selected = dataGrid.current.dataView.getAllSelectedItems();
        setHasSelection(selected.length > 0);
      }
    };

    const getDataGrid = () => (
      <div className="h-full overflow-hidden">
        <SlickGrid
          ref={dataGrid}
          remoteDataSource={`${getBackendUrl()}/reviews/reviewsService`}
          query={reviewsQuery}
          toolbar={showOnlyGrid ? null : toolbarForReviews}
          toolbarClickHandler={toolbarClickHandler}
          columnDefinitions={reviewsGridColumns}
          onClick={recordClick}
          allowPagination
          onSelectedRowsChanged={selectionEvents}
          enableColumnChooser
          callbackForVisibleColumnsUpdate={callbackForVisibleColumnsUpdate}
          gridOptions={{ forceFitColumns: true }}
          onSelectedRowIdsChanged={handleSelectedRowIdsChanged}
          enableColumnPicker={false}
          enableGridMenu={false}
        />
      </div>
    );

    return (
      <div className="flex gap-4 h-full w-full">
        <div className="h-full w-full bg-white flex flex-col overflow-auto">
          {reviewType == recordStatus.ARCHIVED && (
            <div className="flex flex-row items-center border-b border-blue-50 pb-4">
              <div className="pt-2 ps-2">
                <IoChevronBack size={24} className="cursor-pointer" onClick={handleBackToActive} />
              </div>
              <div className="flex flex-col ms-4 pt-2">
                <span className="mb-1">
                  <Text>{t("Archived Reviews")}</Text>
                </span>
                <span className="text-sm">
                  <Text>{t("List of all archived review(s) in this scope")}</Text>
                </span>
              </div>
            </div>
          )}
          {!showOnlyGrid && projectId && !spaceId && getHeader()}
          {getDataGrid()}
        </div>
        {recordProperties.show && recordProperties.details._id && (
          <ReviewProperties
            _id={recordProperties.details._id}
            closeProperties={closeProperties}
            refreshGrid={refreshGrid}
            spaceId={spaceId}
            allowFetchData
            showHeader
            accordionOrder={["details", "reviewFlow"]}
          />
        )}
        {createReviewModal.show && (
          <CreateReviewModal
            spaceId={spaceId}
            refreshGrid={refreshGrid}
            closeModal={closeModal}
            projectId={projectId}
          />
        )}
        {archiveModal.show && (
          <ModalStateDialogComponent
            isVisible={archiveModal.show}
            allowModalPadding={false}
            width="500px"
            headerTitle={reviewType == recordStatus.ACTIVE ? t("Archive Review(s)") : t("Unarchive Review(s)")}
            modelContent={archiveModalContent()}
            onCancel={closeArchiveModal}
            footerContent={archiveModalFooter()}
          />
        )}
        {deleteModal.show && (
          <ModalStateDialogComponent
            isVisible={deleteModal.show}
            allowModalPadding={false}
            width="500px"
            headerTitle={deleteModalHeader()}
            modelContent={deleteModalContent()}
            onCancel={handleDeleteModalCancel}
            footerContent={deleteModalFooter()}
          />
        )}
      </div>
    );
  },
);
ReviewsList.displayName = "ReviewsList";

export default ReviewsList;
